/**
 * @param {!boolean} shouldWarn Whether a confirmation dialog should be displayed when a user attempts to exit the page.
*/
function setConfirmationDialog(shouldWarn) {
  if (shouldWarn) {
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  } else {
    window.removeEventListener('beforeunload', onBeforeUnload);
  }
}

function onBeforeUnload(e) {
  e.preventDefault();
  // Most browsers require the returnValue to be non-null to trigger the popup, even though
  // the actual value is not used directly. Set this to the title of the original popup from
  // the mocks just to be safe in all cases.
  e.returnValue = yext.msg('Are you sure you want to leave?');
}

export default setConfirmationDialog;
